import styled from '@emotion/styled'

const Container = styled.div`
  overflow: hidden;
  position: relative;
`

const Gradient = styled.div`
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.15) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 999;
`

const GradientOverlay = ({ children, className }) => (
  <Container className={className}>
    <Gradient />
    {children}
  </Container>
)

export default GradientOverlay
